import { isSmallScreen } from "./utils";

export function assertSmallScreen() {
  if (!isSmallScreen()) {
    return { path: "/", replace: true };
  }
}
